import $ from 'jquery';
import run from '../../../utilities/run';
require("./resetPasswordScreen.less");







// WEBPACK FOOTER //
// ./src/pages/hcu/resetPasswordScreen/resetPassword.js